export enum ContractorSalesFilter {
  from = 'filters[lead][createdAt][from]',
  to = 'filters[lead][createdAt][to]',
  campaignId = 'filters[campaign][id]',
  campaignIdArray = 'filters[campaign][id][]',
  serviceId = 'filters[service][id]',
  serviceIdArray = 'filters[service][id][]',
}

export enum ContractorSalesSort {
  dateCreated = 'sort[lead][createdAt]',
  fullName = 'sort[lead][fullName]',
  service = 'sort[service][name]',
  campaignName = 'sort[campaign][name]',
  email = 'sort[lead][email]',
  phone = 'sort[lead][phoneNumber]',
}

export enum ManagerSalesFilter {
  from = 'filters[lead][createdAt][from]',
  to = 'filters[lead][createdAt][to]',
  contractorIdArray = 'filters[contractor][id][]',
  serviceIdArray = 'filters[service][id][]',
  campaignsIdArray = 'filters[campaign][id][]',
}

export enum ManagerSalesSort {
  campaignName = 'sort[campaign][name]',
  contractor = 'sort[contractor][companyName]',
  dateCreated = 'sort[lead][createdAt]',
  fullName = 'sort[lead][fullName]',
  phoneNumber = 'sort[lead][phone_number]',
  email = 'sort[lead][email]',
  id = 'sort[lead][id]',
  service = 'sort[service][name]',
}
